import EmptyState from '../DataDisplay/EmptyState';
import ErrorState from '../DataDisplay/ErrorState';

/**
 * Card chrome plus a *resolved* height for the canvas.
 *
 * `relative` + a fixed height + `min-h-0` are all load-bearing: with
 * `maintainAspectRatio: false` and no resolved height, a chart.js canvas grows
 * on every resize until it fills the page.
 */
export default function ChartCard({
  title,
  subtitle,
  actions,
  height = 'h-72',
  loading,
  error,
  isEmpty,
  emptyMessage = 'Nothing to plot for this period.',
  footer,
  children,
}) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-700 dark:bg-slate-800">
      <div className="mb-3 flex flex-wrap items-start justify-between gap-2">
        <div>
          <h3 className="font-semibold text-slate-900 dark:text-white">{title}</h3>
          {subtitle && (
            <p className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">{subtitle}</p>
          )}
        </div>
        {actions}
      </div>
      {error ? (
        <ErrorState message={error} />
      ) : loading ? (
        <div className={`${height} animate-pulse rounded-xl bg-slate-100 dark:bg-slate-700`} />
      ) : isEmpty ? (
        <EmptyState title="No data" message={emptyMessage} />
      ) : (
        <div className={`relative w-full min-h-0 ${height}`}>{children}</div>
      )}
      {footer}
    </div>
  );
}
